import React, { useContext, useState, useEffect } from "react";
import "./style.css";
import Botao from "../../components/Botao/Botao";
import CardDescricao from "../../components/Card/CardDescricao";
import Footer from "../../components/Footer/Footer";
import ModalPix from "../../components/Modal/ModalPix";
import Sucesso from "../../components/Alert/Sucesso";
import Erro from "../../components/Alert/Erro";
import Loading from "../../components/Loading/Loading";
import { NavLink, useNavigate } from "react-router-dom";
import cardPagamento from "../../images/Compra/card.svg";
import cartao from "../../images/Compra/cartao.svg";
import pix from "../../images/Compra/pix.svg";
import { CompraContext } from "../../context/CompraContext";
import InputMask from "react-input-mask";
import { FiAlertTriangle } from "react-icons/fi";
import Lottie from "lottie-react";
import json from "../../images/drjc2eHoKC.json";
import token from "../../images/Certificado/token.svg";
import file from "../../images/Certificado/file.webp";
import certificadoescudo from "../../images/Certificado/certificadoescudo.webp";
import cartaoleitora from "../../images/Certificado/cartaoleitora.svg";
import CardCertificadoSelecionado from "../../components/Card/CardCertificadoSelecionado";

function Compra() {
  const {
    Nome,
    setNome,
    NumeroCartao,
    setNumeroCartao,
    DataValidade,
    setDataValidade,
    CodSeguranca,
    setCodSeguranca,
    GeraPix,
    abreModal,
    setAbreModal,
    encryptCardDetails,
    msgSucesso,
    msgErro,
    setMsgErro,
    loading,
    ProdutoCompra,
    ConsultaProdutos,
    ValidaCupom,
    Cupom,
    setCupom,
    Descricao,
    setDescricao,
    Desconto,
    setDesconto,
    setRevenda,
    VendaKey,
  } = useContext(CompraContext);

  const navigate = useNavigate();
  const StepPagamento = {
    SELECAO_PAGAMENTO: 1,
    PAGAMENTO_PIX: 2,
    PAGAMENTO_CARTAO: 3,
  };
  const [currentStep, setCurrentStep] = useState(
    StepPagamento.SELECAO_PAGAMENTO
  );

  const dataCardSelecionado = {
    icone: verificaIcone(ProdutoCompra?.resumo),
    valor: ProdutoCompra?.anos[0].valor.toFixed(2),
    titulo: ProdutoCompra?.descricaoResumida.split("-")[0],
    modelo: ProdutoCompra?.descricaoResumida.split("-")[0].split(" ")[1],
    formato: ProdutoCompra?.descricaoResumida.split("-")[1],
    validade: ProdutoCompra?.anos[0].descricao,
  };

  const nextStep = () => {
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const prevStep = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const pagarCartao = () => {
    if (typeof NumeroCartao === "undefined" || NumeroCartao === "") {
      setMsgErro("Número do cartão obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      return;
    }
    if (typeof Nome === "undefined" || Nome === "") {
      setMsgErro("Nome obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      return;
    }
    if (typeof DataValidade === "undefined" || DataValidade === "") {
      setMsgErro("Data de validade obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      return;
    }
    if (typeof CodSeguranca === "undefined" || CodSeguranca === "") {
      setMsgErro("CVV obrigatório");
      setTimeout(() => {
        setMsgErro("");
      }, 6000);
      return;
    }
    encryptCardDetails(Cupom, VendaKey)
      .then(() => {
        navigate("/compra-finalizada");
        setNumeroCartao("");
        setNome("");
        setDataValidade("");
        setCodSeguranca("");
        setCupom("");
        setDescricao("");
        setRevenda("");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function verificaIcone(item) {
    if (item.includes("Cartão + Leitora")) {
      return cartaoleitora;
    } else if (item.includes("Cartão")) {
      return cartao;
    } else if (item.includes("Token")) {
      return token;
    } else if (item.includes("Arquivo")) {
      return file;
    } else if (item.includes("Nuvem")) {
      return certificadoescudo;
    } else {
      return certificadoescudo;
    }
  }

  useEffect(() => {
    setCupom("");
    setDescricao("");
    setDesconto("");
    window.scrollTo(0, 0);
    if (ProdutoCompra) {
      ConsultaProdutos(ProdutoCompra.id, ProdutoCompra.anos[0]?.id);
    }
  }, []);

  const renderContent = (step) => {
    switch (step) {
      case StepPagamento.SELECAO_PAGAMENTO:
        return (
          <div className="container-compra">
            <div className="container-titulo-pagamento">
              <h3>Pagamento: </h3>
              <h4>Escolha como pagar seu certificado</h4>

              <i style={{ width: "65%", fontSize: "14px" }}>
                A efetivação do pagamento é feita instantaneamente.
              </i>
            </div>

            {/* Pague com pix */}
            <div className="container-forma-pagamento">
              <button
                className="pagamento-compra"
                style={{ marginTop: "30px" }}
                onClick={() => setCurrentStep(StepPagamento.PAGAMENTO_PIX)}
              >
                <img src={pix} alt="Ícone de PIX" />
                <p>Pague com PIX</p>
              </button>
              {/* Pague com crédito */}
              <button
                className="pagamento-compra"
                onClick={() => setCurrentStep(StepPagamento.PAGAMENTO_CARTAO)}
              >
                <img src={cardPagamento} alt="Ícone de cartão" />
                <p>Pague com Cartão de Crédito</p>
              </button>
            </div>
            <div style={{ width: "55%", paddingTop: "20px" }}>
              <i style={{ width: "65%", fontSize: "14px" }}>
                Ao prosseguir, você declara estar ciente de que a validação e
                emissão do certificado digital são realizadas pela AR Gcert,
                conforme regulamentação do ICP- Brasil.
              </i>
            </div>
          </div>
        );

      case StepPagamento.PAGAMENTO_PIX:
        return (
          <div className="container-compra">
            <div className="container-titulo-pagamento">
              <h3>Pagamento: </h3>
              <h4>Você escolheu pagamento por PIX</h4>

              <i
                className="container-italic-qrcode"
                style={{ fontSize: "14px" }}
              >
                Será gerado um QR Code de R$
                {ProdutoCompra.anos[0].valor.toFixed(2)} válido por 10 minutos
                para a realização do pagamento da compra do 
                {ProdutoCompra.resumo}.
              </i>
            </div>

            <div className="container-buttons">
              <button className="btn-primario-outline" onClick={prevStep}>
                Voltar
              </button>
              <button
                className="btn-primario"
                onClick={() => GeraPix(Cupom, VendaKey)}
              >
                Gerar QR Code
              </button>
            </div>
          </div>
        );

      case StepPagamento.PAGAMENTO_CARTAO:
        return (
          <div className="container-compra">
            <div className="container-titulo-pagamento">
              <h3>Pagamento: </h3>
              <h4 style={{ margin: "10px 0 10px 0" }}>
                Você escolheu pagamento por cartão de crédito
              </h4>

              <i style={{ width: "65%", fontSize: "14px" }}>
                Preencha os dados abaixo para concluir a sua compra.
              </i>
            </div>

            <div className="pagamento-compra-dados">
              <div className="input" style={{ width: "100%" }}>
                <InputMask
                  mask="9999 9999 9999 9999"
                  onChange={(e) => setNumeroCartao(e.target.value)}
                  value={NumeroCartao}
                  name="numerocartao"
                  id="numerocartao"
                  placeholder="Número do cartão de crédito*"
                />
              </div>
              <div className="input" style={{ width: "100%" }}>
                <input
                  type="text"
                  name="nomecompleto"
                  id="nomecompleto"
                  value={Nome}
                  onChange={(e) => setNome(e.target.value)}
                  placeholder="Nome completo. Conforme impresso no cartão*"
                />
              </div>
              <div className="input-compra" style={{ width: "100%" }}>
                <div className="input" style={{ width: "48%" }}>
                  <InputMask
                    mask="99/9999"
                    onChange={(e) => setDataValidade(e.target.value)}
                    value={DataValidade}
                    name="datavalidade"
                    id="datavalidade"
                    placeholder="Validade*"
                  />
                </div>
                <div className="input" style={{ width: "49%" }}>
                  <InputMask
                    mask="999"
                    onChange={(e) => setCodSeguranca(e.target.value)}
                    value={CodSeguranca}
                    name="cvv"
                    id="cvv"
                    placeholder="CVV*"
                  />
                </div>
              </div>
            </div>

            <div className="container-buttons">
              <button
                className="btn-primario-outline"
                onClick={() => setCurrentStep(StepPagamento.SELECAO_PAGAMENTO)}
              >
                Voltar
              </button>
              <button className="btn-primario" onClick={() => pagarCartao()}>
                Pagar
              </button>
            </div>
          </div>
        );
      default:
        return "";
    }
  };

  return (
    <>
      {abreModal && <ModalPix close={setAbreModal} />}
      {msgSucesso && <Sucesso />}
      {msgErro && <Erro />}
      {loading && <Loading />}
      <section className="page-compra">
        {ProdutoCompra ? (
          <>
            <div className="compra">
              <CardCertificadoSelecionado
                image={dataCardSelecionado.icone}
                modelo={dataCardSelecionado.modelo}
                formato={dataCardSelecionado.formato}
                titulo={dataCardSelecionado.titulo}
                validade={dataCardSelecionado.validade}
                valor={dataCardSelecionado.valor}
              />
              {renderContent(currentStep)}
            </div>
          </>
        ) : (
          <>
            <div className="elemento-centralizado">
              <FiAlertTriangle className="icon-alert" />
            </div>
            <h2 style={{ textAlign: "center", marginTop: "20px" }}>
              Nenhum produto selecionado
            </h2>
            <div
              style={{ width: "300px", height: "300px", margin: "50px auto" }}
            >
              <Lottie animationData={json} loop={true} />
            </div>
            <div className="elemento-centralizado">
              <NavLink to="/certificado">
                <Botao texto={"Comprar produtos"} />
              </NavLink>
            </div>
          </>
        )}
      </section>
      <Footer footerCertificado={true} />
    </>
  );
}

export default Compra;
